import React from 'react'
import WorkerTop from '../workerTop/WorkerTop'
import '../worker/Worker.css'
import WorkerReview from '../workerReview/WorkerReview'
import WorkerTab from '../workerTabs/WorkerTab'

const Worker = () => {
  return (
    <div className='dashboard-content-box dashboard-profile'>
        <div className='top-profile-box'>
            <WorkerTop />
        </div>
        <div className='reviews-sec'>
          <WorkerReview />
        </div>
        <div className='worker-tabs-bottom-sec'>
          <WorkerTab />
        </div>
    </div>
  )
}

export default Worker